import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useUserProfile } from '@/hooks/useUserProfile';

/* A FUNÇÃO ADICIONAL (Douglas 28/10/2026): a pessoa continua com a função dela
   e também trabalha como BKO Contrato (a Lisiane, supervisora). Recebe pedidos
   no rodízio, trava como a BKO e as triagens do Contrato abrem nos pedidos
   dela. Régua no banco: `fn_trabalha_como` e `usuario_funcao_adicional`. */

export interface FuncaoAdicional {
  funcao: string;
  desde: string;
  por_nome: string | null;
  pedidos_abertos: number;
}

type Rpc = (fn: string, args: Record<string, unknown>) => Promise<{ data: unknown; error: { message?: string } | null }>;
export const rpcFuncaoAdicional = supabase.rpc.bind(supabase) as unknown as Rpc;

export function useFuncoesAdicionais(usuarioId: string | null | undefined) {
  return useQuery({
    queryKey: ['funcoes-adicionais', usuarioId],
    enabled: !!usuarioId,
    staleTime: 60_000,
    queryFn: async (): Promise<FuncaoAdicional[]> => {
      const { data, error } = await rpcFuncaoAdicional('fn_funcoes_adicionais', { p_usuario: usuarioId });
      if (error) throw new Error(error.message || 'Não deu para ler a função adicional.');
      return (data ?? []) as FuncaoAdicional[];
    },
  });
}

export function useContratoAdicional() {
  const { data: perfil } = useUserProfile();
  const { data } = useFuncoesAdicionais(perfil?.id);
  const principal = perfil?.funcao === 'BKO_CONTRATO';
  const adicional = !principal && (data ?? []).some((f) => f.funcao === 'BKO_CONTRATO');
  return { principal, adicional };
}
